import React from "react";
import { useTheme } from "../context/themeContext";
import { lightTheme, darkTheme } from "../assets/theme";

const ThemeSettings = () => {
  const { theme, setTheme } = useTheme(); // ✅ correct destructuring

  return (
    <div
      style={{
        background: theme.background,
        color: theme.text,
        padding: "1rem",
      }}
    >
      <h2>Choose Theme</h2>
      <button onClick={() => setTheme(lightTheme)}>Light</button>
      <button onClick={() => setTheme(darkTheme)}>Dark</button>
    </div>
  );
};

export default ThemeSettings;
